import React from "react";
import styled from "@emotion/styled";

const StyledCardDiploma = styled.div`
  padding: 2em;
  margin: 1em;
  margin-bottom: 2em;
  font-size: 1.3em;
  text-align:center;
  position:relative;
  transition:300ms;
  opacity:0.6;
  &:before{
    content:"";
    position:absolute;
    top:0;
    left:0;
    rigth:0;
    bottom:0;
    border: solid 2px black;
    transition:300ms;
    transform:scale(0);
    opacity:0;
    width:100%;
    border-radius: 6px;
    z-index: -1;
  }
  &:hover{
  opacity:1;
  }
  &:hover:before {
    border-bottom: solid 2px black;
    transform:scale(1.1);
    opacity:1;
  }
`;

const  LinkDiploma = styled.a`
    cursor:pointer;
    color: #ba7967;
    display:block; 
    text-align:center;
    margin-top:1rem;

`
const CardDiploma = ({ titulo, plataforma, link }) => {
  return (
    <StyledCardDiploma>
      <p className="about-course-title">
        <strong>{titulo}</strong>
      </p>
      <span> {plataforma} </span>
      <span className="">
        <LinkDiploma href={link ? link : "#!"}>
          Link a la diploma
        </LinkDiploma>
      </span>
    </StyledCardDiploma>
  );
};

export default CardDiploma;
